<template>
  <div class='aboutDetail'>
    <section class="section detail-section centerbox columnbox news-detail">
      <div class="content centerbox columnbox w1200">
        <h2 style="text-align: center;">{{ newsDetail.title }}</h2>
        <label>{{ newsDetail.time }}</label>
      </div>
      <div class="main-content w1200">
        <div v-html="content"></div>
        <p><br></p>
        <p><br></p>
        <p><br></p>
      </div>

      <div class="bottom-slide w1200 betweenbox flex-wrap">
        <a class="return-a centerbox" @click="backList()"><img src="../../assets/images/r-ico.png"> 返回列表</a>
        <div class="columnbox flexbox slide-ul align-start">
          <a v-if="newsDetail.next != '无'" class="prev-a flexbox" @click="goAboutDetail(newsDetail.next)">上一篇：{{ newsDetail.next }}</a>
          <a v-if="newsDetail.prev != '无'" class="next-a flexbox" @click="goAboutDetail(newsDetail.prev)">下一篇：{{ newsDetail.prev }}</a>
        </div>

      </div>
    </section>

  </div>
</template>
  
  <script>
import axios from 'axios'
export default {
  metaInfo() {
    return {
      title: "健新医疗荣膺“2023青岛十大资本青睐企业-健新",
      meta: [
        { name: "keywords", content: "keyword1, keyword2, keyword3" },
        { name: "description", content: "Page description" },
      ],
    };
  },
  mounted() {

  },
  data() {
    return {
      content: "",
      newsDetail: {}
    }
  },
  created() {
    let data = {
      Title: this.$route.query.title + 'Content',
      ForumTypeCode: 'TYGSXW'
    }
    this.getNewsContent(data)
    this.getNewsList()
  },
  methods: {
    getNewsContent(data) {
      axios
        .post("api/Forum/GetDoc", { ...data })
        .then((res) => {
          if (res) {
            this.content = res.data.OutputData.Content
          } else {
            this.$message({
              type: "error",
              message: "请求数据失败",
            });
          }
        });
    },
    getNewsList() {
      let data = {
        Title: this.$route.query.title,
        ForumTypeCode: 'TYGSXW'
      }
      axios
        .post("api/Forum/GetDoc", { ...data })
        .then((res) => {
          if (res) {
            this.newsDetail = JSON.parse(res.data.OutputData.Content);
          } else {
            this.$message({
              type: "error",
              message: "请求数据失败",
            });
          }
        });
    },
    goAboutDetail(name) {
      this.$router.push({
        name: "aboutDetail",
        query: {
          title: name
        }
      })
    },
    // 返回列表
    backList() {
      // this.$router.go(-1)
      this.$router.push({
        name:"jxAbout",
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/base.less";

.aboutDetail {
  width: 100%;
  line-height: 1.7;

  .section {

    img {
      max-width: 100%;
      border: none;
      font-size: 0;
      outline-width: 0PX;
      vertical-align: top;
      margin: 0;
      padding: 0;
      outline: 0;
    }
    .content {
      h2 {
        width: 100%;
        max-width: 100%;
        color: #333;
        font-size: 24PX;
        padding-top: 32PX;
        padding-bottom: 20PX;
      }
      label {
        width: 100%;
        max-width: 100%;
        font-size: 16PX;
        color: #c1c1c1;
        padding-bottom: 20PX;
        border-bottom: 1PX solid #D2D2D2;
        margin-bottom: 20PX;
      }
    }
    .main-content {
      color: #333;
      /deep/img {
        max-width: 100%;
      }
    }
    .bottom-slide {
      padding-right: 0;
      padding-left: 0; 
      font-size: 16PX;
      // margin-top: 70PX;
      // padding: 16PX 60PX;
      border-bottom: 1PX solid #D2D2D2; // margin-bottom: 20PX;
      a {
        font-size: 14PX;
        cursor: pointer;
        color: #333;
      }
      .return-a {
        border: 1PX dashed #dcdcdc;
        color: #a5a5a5;
      }
      a.return-a {
        color: #969696;
        margin-right: 50PX;
      }
      .align-start {
        webkit-box-align: start;
        -moz-align-items: flex-start;
        -webkit-align-items: flex-start;
        align-items: flex-start;
      }
      a.next-a {
        color: #0068b7;
      }
    }
  }

  @media only screen and (min-width: 960PX) {
    .section {
      padding-top: 130PX;
    }
    .w1200 {
      width: 1200PX;
      margin: 0 auto;
      height: auto;
    }
    .bottom-slide {
     
      margin-top: 70PX;
      padding: 16PX 60PX;
      margin-bottom: 20PX;
      .return-a {
        width: 124PX;
        height: 46PX;
        font-size: 16PX;
      }
    }
  }
  @media screen and (max-width:959PX) and (min-width:320PX) {
    .w1200 {
      height: auto;
      width: 100%;
      padding-right: 1.44rem;
      padding-left: 1.44rem;
    }
    .section {
      padding-top: 3.52rem;
      .content {
        h2 {
          width: 100%;
          max-width: 100%;
          font-size: 1.12rem;
          padding-top: 1.28rem;
          padding-bottom: 0.8rem;
        }
        label {
          width: 100%;
          font-size: 0.96rem;
          padding-bottom: 0.96rem;
          margin-bottom: 0.96rem;
        }
      }
      .bottom-slide {
        margin-top: 2.296rem;
        padding: .6976rem 1.376rem;
        margin-bottom: .764rem;
        .return-a {
          width: 6rem;
          height: 2.24rem;
          font-size: .96rem;
        }
      }
    }
  }
}
</style>